import { Origin } from '../components/AppError/useConfigurationErrorHandler';
import { config } from '../config';
const getOriginByQueryParams = (
  storeId: string | null,
  source: string | null
): Origin => {
  if (config.tenant === 'ck') {
    if (storeId) {
      return { type: 'storeId', storeId: storeId };
    }
    return null;
  }
  if (storeId === null) {
    if (source === null) return null;
    return { source, type: 'socialMedia' };
  }
  return { type: 'storeId', storeId };
};
export default getOriginByQueryParams;
